<script setup lang="ts">
import type { Product } from '~~/graphql/operations'

const props = defineProps<{
  product: {
    value: number
    label: string
  }
}>()

// Add try-catch to handle JSON parsing errors
const parsedProduct = computed(() => {
  try {
    if (!props.product?.label) return null
    return JSON.parse(props.product.label) as Product
  } catch (e) {
    console.error('Error parsing product data:', e)
    return null
  }
})

// Add null checks for all computed properties
const deliveryDays = computed(
  () => parsedProduct.value?.manufacturer?.deliveryDays,
)

const price = computed(() => {
  const pp = parsedProduct.value?.productPrice
  return pp ? (+pp.priceGross / 100).toFixed(2) : '-.--'
})

// Add a check to determine if the product has valid data
const hasValidData = computed(
  () => !!parsedProduct.value && !!parsedProduct.value.defaultText,
)
</script>
<template>
  <div v-if="product && hasValidData">
    <p class="font-bold">
      {{ parsedProduct?.defaultText?.name || 'Unknown Product' }}
    </p>
    <p class="text-xs">
      Product Number: {{ parsedProduct?.productNumber || 'N/A' }}
    </p>
    <p class="text-xs">
      {{
        parsedProduct?.manufacturer?.defaultText?.name || 'Unknown Manufacturer'
      }}
    </p>
    <p class="text-xs">Price gr: {{ price }}</p>
  </div>
  <div v-else-if="product">
    <p class="font-bold text-red-500">Invalid Product Data</p>
    <p class="text-xs">Please try again or contact support</p>
  </div>
</template>
